import { toast } from "react-toastify";
import { BASE_URL } from "../../global";
import axiosWithToken from "./axiosTokenConfig";

export const uploadJsonData = async (dataToUpload) => {
    try {
        const jsonString = JSON.stringify(dataToUpload, null, 2);
        const blob = new Blob([jsonString], { type: "application/json" });
        const file = new File([blob], `data_${Date.now()}.json`, { type: "application/json" });

        const data = new FormData();
        data.append("fileToUpload", file);

        const res = await axiosWithToken.post(BASE_URL + `fileUpload/fileUpload.php`, data);

        if (res.status == 200) {
            // toast.success("File Uploaded Successfully!");
            return res.data; // uploaded file URL
        }
    } catch (err) {
        toast.error("Something went wrong");
        throw err;
    }
};


export const fetchJsonFromUrl = async (fileUrl) => {
  try {
    const res = await fetch(fileUrl);

    if (!res.ok) {
      throw new Error(`Request failed with status ${res.status}`);
    }

    const text = await res.text();
    return typeof text === "string" ? JSON.parse(text) : text;
  } catch (err) {
    throw err;
  }
};